import { Steps } from 'antd'
import EmptyCircle from 'components/icons/EmptyCircle'
import StepsCompleted from 'components/icons/StepsCompleted'
import StepsIcon from 'components/icons/StepsIcon'
import React from 'react'
import styled from 'styled-components'
import { COLORS } from 'theme'

const { Step } = Steps

const Div = styled.div`
  .ant-steps-item-tail::after {
    border-left: 2px solid #e0e0e0 !important;
    // You can adjust width, color, etc. here
  }
`
const Title = styled.h2`
  font-weight: 500;
  font-size: 15px;
  line-height: 21px;
  color: ${props => props.textcolor};
`
const StyledStep = styled(Step)`
  .ant-steps-item-title {
    width: 100%;
    padding-bottom: 5px;
    border-bottom: 1px solid ${COLORS.GREY_T_90};
  }
`
const StyledSteps = styled(Steps)`
  /* .ant-steps-item .ant-steps-item-finish .ant-steps-item-custom {
    cursor: pointer;
  } */
  cursor: pointer;
`
export const RoundDiv = styled.p`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  color: #999fac;
`
const getIcon = (step, isStepCompleted, progressCheck, currentState) => {
  if (step?.activeKey === currentState) {
    return <StepsIcon />
  } else if (isStepCompleted) {
    return <StepsCompleted progressCheck={progressCheck} />
  } else {
    return <StepsIcon />
  }
}

// const Icon = ({ step, current, progressCheck, currentState }) => {
//   const isStepCompleted = step.completed
//   const isCurrentStep = step?.activeKey === current
// if (current > step?.activeKey|| current < step?.activeKey ) {
//   return isStepCompleted ? (
//     <StepsCompleted progressCheck={progressCheck} />
//   ) : (
//     <StepsIcon />
//   )
// }

// if (isCurrentStep) {
//   return isStepCompleted ? (
//     <StepsCompleted progressCheck={progressCheck} />
//   ) : (
//     <StepsIcon />
//   )
// }

//   return <EmptyCircle />
// }
const Icon = ({ step, current }) => {
  if (step.completed) {
    return <StepsCompleted />
  }
  if (step.activeKey === current) {
    return <StepsIcon />
  }
  // Only show EmptyCircle for future steps
  if (step.activeKey > current) {
    return <EmptyCircle />
  }
  // For steps before current that are not completed
  return <StepsIcon />
}
const Steppor = ({
  steps,
  direction = 'vertical',
  size = 'small',
  current = '1',
  progressCheck = false,
  currentState,
  onTabChange,
  roleLoading,
  setRoleLoading,
  ...props
}) => {
  return (
    <Div>
      <StyledSteps
        direction={direction}
        size={size}
        current={current}
        {...props}
      >
        {steps?.map((step, index) => (
          <StyledStep
            key={index + step}
            icon={
              <Icon
                step={step}
                current={current}
                progressCheck={progressCheck}
                currentState={currentState}
              />
            }
            title={
              <>
                <Title
                  textcolor={
                    currentState === step?.activeKey
                      ? COLORS.GREY_T_30
                      : COLORS.GREY_T_60
                  }
                >
                  {step?.title}
                </Title>
                {index < steps.length - 1 && (
                  <div
                    style={{
                      marginTop: '10px',
                      borderBottom: '1.5px solid #E6E7EA',
                    }}
                  />
                )}
              </>
            }
            description={
              <RoundDiv
                textcolor={
                  step?.activeKey == current
                    ? COLORS.GREY_T_30
                    : COLORS.GREY_T_60
                }
              >
                {step?.description}
              </RoundDiv>
            }
            onClick={() => {
              if (step?.activeKey == current) {
                onTabChange(step?.activeKey)
              }
            }}
          />
        ))}
      </StyledSteps>
    </Div>
  )
}

export default Steppor
